import { mapActions, mapGetters } from 'vuex'
// import isEmptyObject from '@/module/util/empty-object'

export default {

	methods: {
		...mapActions('content', ['loadContent']),
		...mapActions('provider', ['setCurrentProvider'])
	},

	computed: {
		...mapGetters('provider', [
			'overview',
			'getProvider',
			'getCurrentProvider',
			'getProviderList',
			'getProviderName'
		]),
		...mapGetters('content', [
			'getContent',
			'getContentKey'
		]),

		/**
		 * @func provider
		 * @desc Get the current provider
		 */
		provider() {
			return this.getProvider
		},

		currentProvider() {
			return this.getCurrentProvider
		},

		/**
		 * @func providers
		 * @desc Get all providers
		 */
        providers() {
            return this.getProviderList
        },

		profiles() {
			if (this.provider)
				return this.provider.profile
		},

		/**
		 * @func labels
		 * @desc Get all labels for the current provider
		 */
		labels() {
			if (this.provider)
				return this.provider.label || []
		},

        /**
         * @func filters
         * @desc Array of all active filters for this provider
         */
		filters() {
			if (this.provider)
				return this.provider.filter || []
		},
		/**
		 * @func patientCount
		 * @desc Number of patients
		 */
        patientCount() {
            if (this.patients)
                return Object.keys(this.patients).length
            return 0
        },
		/**
		 * @func count
		 * @desc Count object for providers
		 */
        count() {
			if (this.provider)
				return this.provider.count
			else
				return {}
		},
	}
}
